<template>
    <div
        class="due-date"
        :id="tourId"
        :class="{ 'disabled-due-date': disable }"
        :title="disable ? 'Task is completed' : ''"
    >
        <CalenderCompo
            v-model="dateValue"
            :hideExtraLayouts="['time', 'minutes', 'hours', 'seconds']"
            :isShowDateAndicon="isShowDateAndicon"
            menuClass="calender-menu-class-duedate"
            @update:model-value="handleDateUpdate"
            :autoposition="autoposition"
            :useCustomTrigger="useCustomTrigger"
            :position="position"
            :overdue="overdue"
            :minDate="minDate"
            :maxDate="maxDate"
            :isWithoutBorderImage="isWithoutBorderImage"
            :format="format"
            :disabled="disable"
            :displayColor="displayColor"
        >
        </CalenderCompo>
    </div>
</template>

<script setup>
//Import
import { ref, defineComponent, defineProps, defineEmits, watch } from 'vue';
import CalenderCompo from '@/components/atom/CalenderCompo/CalenderCompo.vue';

//Define Emits, Props, & Refs
const emit = defineEmits(['SelectedDate'])

defineComponent({
    components: { CalenderCompo }
})

const props = defineProps({
    displyDate: {
        required: true
    },
    disabledDates: {
        type: Array,
        default: () => []
    },
    id: {
        type: String,
        default: ''
    },
    isShowDateAndicon: {
        type: Boolean,
        default: false
    },
    allowTillCurrentDate: {
        type: Boolean,
        default: false
    },
    autoposition: {
        type: Boolean,
        default: true
    },
    position: {
        type: String,
        default: ''
    },
    overdue: {
        type: Boolean,
        default: false
    },
    tourId: {
        type: String,
        default: ''
    },
    minDate: {
        type: [Date, String],
        default: ''
    },
    maxDate: {
        type: [Date, String],
        default: ''
    },
    isWithoutBorderImage: {
        type: Boolean,
        default: false
    },
    format: {
        type: String,
        default: ''
    },
    useCustomTrigger: {
        type: Boolean,
        default: false
    },
    disable: {
        type: Boolean,
        default: false
    },
    displayColor: {
        type: String,
        default: ''
    }
})

const dateValue = ref(
    props.displyDate && props.displyDate != 0
        ? props.displyDate?.seconds
            ? new Date(props.displyDate.seconds * 1000)
            : props.displyDate
        : ''
);

watch(() => props.displyDate, (newVal) => {
    dateValue.value = newVal && newVal != 0
        ? newVal?.seconds
            ? new Date(newVal.seconds * 1000)
            : new Date(newVal)
        : '';
})

function handleDateUpdate($event) {
    if (props.disable) return;
    emit('SelectedDate', { dateVal: $event, id: props.id });
}
</script>

<style src="./style.css"></style>

<style scoped>
.disabled-due-date {
    cursor: not-allowed !important;
}

.disabled-due-date * {
    cursor: not-allowed !important;
    pointer-events: none;
}
</style>
